(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-collection__main"]) return;
  try {
      if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSection(section) {
    if (section.dataset.depictInit === '1') return;
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    section.dataset.depictInit = '1';

    var prev = section.querySelector('[data-depict-rec-prev]');
    var next = section.querySelector('[data-depict-rec-next]');

    // Sets data-depict-overflow when the row scrolls (drives arrow visibility)
    // and the nav-button disabled state. Skipped while display:none
    // (clientWidth 0); the ResizeObserver re-runs it once the Depict extension
    // reveals the section.
    function update() {
      if (!grid.clientWidth) return;
      var max = grid.scrollWidth - grid.clientWidth;
      var hasOverflow = max > 1;
      var sl = Math.abs(grid.scrollLeft);
      var atStart = sl <= 1;
      var atEnd = sl >= max - 1;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (hasOverflow) {
        section.setAttribute('data-depict-overflow', '');
      } else {
        section.removeAttribute('data-depict-overflow');
      }
    }

    // No behavior key: the grid's CSS scroll-behavior decides smooth vs instant,
    // so prefers-reduced-motion is honored without JS.
    function scrollPage(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.9 });
    }
    if (prev) prev.addEventListener('click', function () { scrollPage(-1); });
    if (next) next.addEventListener('click', function () { scrollPage(1); });

    grid.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(grid);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();
})();
